import trackService from "@/services/track";
import router from "@/router";

export default {
  namespaced: true,
  state: {
    campaignList : []
  },

  mutations: {
    setCampaignList(state,value){
        state.campaignList = value
    }
  },

  actions: {
    getCampaignList({ commit }) {
        trackService
        .getCampaignList()
        .then(response => {
          commit("setCampaignList", response);
        })
        .catch(error => console.log(error));
    },
  },

  getters: {
    campaignList : state => {
        return state.campaignList
    }
  }
}